import { render, staticRenderFns } from "./thirdOauth.vue?vue&type=template&id=62beff10&scoped=true&"
import script from "./thirdOauth.vue?vue&type=script&lang=js&"
export * from "./thirdOauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62beff10",
  null
  
)

export default component.exports